import { Breadcrumb, Col, Divider, Flex, Layout, Row, Button } from "antd";
import { Info } from "components/elements";
import { useSelector } from "react-redux";

import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import styles from "../styles/SocialSecurityContribution.module.css";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"

const SocialSecurityContributionView = ({
  isLoading = false,
  currentSocialSecurityContribution = {},
  onEdit = () => { },
}) => {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  return (
    <>
      <Layout style={{ rowGap: "24px" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("masterdata.header"), href: "" },
            { title: t("social_security_contribution.header") },
          ]} />
          <h2>{t("social_security_contribution.header")}</h2>
        </Flex>
        <Content>
          <Row style={{
            marginBottom: "24px",
          }}>
            <Col span={24}>
              {roles.includes("UPDATE_MASTER_DATA_LIST|SOCIAL_SECURITY_CONTRIBUTION") &&
                <Flex justify="end">
                  <Button onClick={onEdit} type="primary"
                    style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
                  >
                    <Flex align="center" justify="center" gap={8}>
                      <EditIcon />
                      {t("common.edit").toUpperCase()}
                    </Flex>
                  </Button>
                </Flex>
              }

            </Col>
          </Row>
          <div className="card">
            <b className={styles.infoTopic}>
              {t("social_security_contribution.label.social_security_rate")}
            </b>
            <Divider />
            <Row gutter={24}>

              <Col span={12} style={{
                marginBottom: "10px",
              }}>
                <Info
                  label={t("social_security_contribution.label.lowest_base_salary")}
                  value={get2DecimalPointsWithCommas(currentSocialSecurityContribution.lowestBaseSalary) + " " + t('social_secure_contribution.label.thb')} />
              </Col>
              <Col span={12}>
                <Info
                  label={t("social_security_contribution.label.highest_base_salary")}
                  value={get2DecimalPointsWithCommas(currentSocialSecurityContribution.highestBaseSalary) + " " + t('social_secure_contribution.label.thb')} />
              </Col>
              <Col span={12} >
                <Info
                  label={t("social_security_contribution.label.insurance_person_contribution_rate")}
                  value={get2DecimalPointsWithCommas(currentSocialSecurityContribution.insurancePersonContributionRate) + " %"} />
              </Col>
              <Col span={12}>
                <Info
                  label={t("social_security_contribution.label.corporate_contribution_rate")}
                  value={get2DecimalPointsWithCommas(currentSocialSecurityContribution.corporateContributionRate) + " %"} />
              </Col>
              <Col span={12} style={{
                marginBottom: "10px",
              }}>
                <Info
                  label={t("social_security_contribution.label.lowest_subvention")}
                  value={get2DecimalPointsWithCommas(currentSocialSecurityContribution.lowestSubvention) + " " + t('social_secure_contribution.label.thb')} />
              </Col>
              <Col span={12}>
                <Info
                  label={t("social_security_contribution.label.highest_subvention")}
                  value={get2DecimalPointsWithCommas(currentSocialSecurityContribution.highestSubvention) + " " + t('social_secure_contribution.label.thb')} />
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default SocialSecurityContributionView;
